module.exports = __webpack_public_path__ + "static/media/BankingPage.cf52f3c2.gif";